export default __webpack_public_path__ + "static/char-v-31-ja-6130e4dbe3738c785639a279b87c7210.mp4";